/** @jsx React.DOM */
var React = require('react/addons')
var remotes = require('../../helpers/remotes')
var cx = React.addons.classSet

var RemoteState = React.createClass({displayName: 'RemoteState',
  getInitialState: function() {
    return {
      state: 'connecting'
    }
  },

  componentWillMount: function() {
    this.remote = remotes.nodes
    this.remote.on('state', this.remoteStateHandler)
  },

  componentWillUnmount: function() {
    this.remote.off('state', this.remoteStateHandler)
  },

  remoteStateHandler: function(state) {
    this.setState({ state: state })
  },

  render: function() {
    return React.DOM.span({
      style: { 'text-transform': 'capitalzie'}, 
      className: cx({
        label: 'true',
        'label-success': this.state.state == 'online',
        'label-danger': this.state.state == 'offline',
        'label-warning': this.state.state == 'connecting'
       })
    }, 
     this.state.state
    )
  }
})

module.exports = RemoteState



//////////////////
// WEBPACK FOOTER
// ./src/partials/footer/remote-state.jsx
// module id = 358
// module chunks = 0